<template>
    <v-card class="fill-height">
        <v-toolbar card dark color="primary">
            <v-toolbar-title>Productinformatie</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="fill-height">
            <product-info :product="product" />
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn color="danger" @click="onDeleteClick">
                <v-icon class="mr-2">delete</v-icon>
                Verwijderen
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import ProductInfo from './ProductInfo'

export default {
    components: {
        ProductInfo,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onDeleteClick () {
            this.$emit('delete')
            this.$emit('close')
        },
    },
}
</script>
